import React, { useState } from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap';
import Button from '../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

type Props = {
  onApplyMeritToAll: (meritPercent: number) => void;
};

// "Apply a single merit % across every row" control, in its own white card.
// `flex-grow-1` lets it fill the left column so its bottom lines up with the
// Results card; the body centres its content so the card doesn't look empty.
export const ApplyMeritControl: React.FC<Props> = ({ onApplyMeritToAll }) => {
  const t = useNamespacedTranslation('compensationReviews.toolbar');
  const [merit, setMerit] = useState('');

  return (
    <Card className="flex-grow-1">
      <Card.Body className="d-flex flex-column justify-content-center">
        <div className="compensation-merit-title mb-2">{t('applyMerit')}</div>
        <div className="d-flex align-items-stretch gap-2">
          <InputGroup className="compensation-merit-input">
            <Form.Control
              type="number"
              step="0.01"
              value={merit}
              aria-label={t('applyMerit')}
              onChange={(event) => setMerit(event.target.value)}
            />
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup>
          <Button
            variant="outline-primary"
            label={t('applyToAll')}
            disabled={merit === ''}
            onClick={() => onApplyMeritToAll(Number(merit) || 0)}
          />
        </div>
        <div className="text-muted small mt-2">{t('applyMeritHint')}</div>
      </Card.Body>
    </Card>
  );
};
